import { render } from "./EmergencyAlerts.vue?vue&type=template&id=9022fd6a"
import script from "./EmergencyAlerts.vue?vue&type=script&lang=js"
export * from "./EmergencyAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__